/**
 * Defines static variables corresponding to the various formatting possibilities
 */

export const Format = {
  SUBSCRIPT: 'subscript',
  SUPERSCRIPT: 'superscript',
  SUPERIMPOSE: 'superimpose',
  TEXT: 'text',
};
